/** Check if a string is already URI-encoded. */
export function isEncoded(str: string): boolean {
  try {
    return decodeURIComponent(str) !== str;
  } catch (e) {
    return false;
  }
}

/** Encode a URI component only if it's not already encoded. */
export function smartEncodeURIComponent(str: string): string {
  try {
    return isEncoded(str) ? str : encodeURIComponent(str);
  } catch {
    return encodeURIComponent(str);
  }
}

/** Safely decode a URI component, without throwing on malformed input. */
export function smartDecodeURIComponent(str: string): string {
  try {
    return decodeURIComponent(str);
  } catch {
    return str;
  }
}
